import { DifficultyLevel, ModuleId } from '../types'
import { LEVELS, LevelConfig } from './levels'
import { MODULES } from '../data/modules'

// System Groups
export type GroupId = 6 | 7 | 8

export const GROUPS: GroupId[] = [6, 7, 8]

// Starting Period — when the student stepped into their group
export type StartingPeriod = 'B' | 'M' | 'E'

export const STARTING_PERIODS: {
  id: StartingPeriod
  label: string
  description: string
}[] = [
  { id: 'B', label: 'Begin', description: 'Start van het schooljaar' },
  { id: 'M', label: 'Midden', description: 'Halverwege het schooljaar' },
  { id: 'E', label: 'Eind', description: 'Einde van het schooljaar' },
]

/**
 * Get the starting level ID for a group + period combination.
 * Maps to the first (non-plus) level of that period.
 * E.g., Group 7 + Period M → M7 (level 203)
 */
export function getStartingLevelForPeriod(
  group: GroupId,
  period: StartingPeriod,
): number {
  const match = LEVELS.find(
    (l) => l.group === group && l.period === period && !l.isPlus,
  )
  // Fallback to first level of group
  return match?.id ?? LEVELS.find((l) => l.group === group)?.id ?? 101
}

// Configuration Interface
export interface SystemConfig {
  groups: GroupId[]
  modules: typeof MODULES
  levels: LevelConfig[]
  version: string
}

// Centralized System Configuration
export const SYSTEM_CONFIG: SystemConfig = {
  groups: GROUPS,
  modules: MODULES,
  levels: LEVELS,
  version: '2.0.0',
}

// Helper to get levels for a specific group
export const getLevelsForGroup = (group: GroupId): LevelConfig[] => {
  return LEVELS.filter((level) => level.group === group)
}

// Validation Utilities
export interface ValidationResult {
  valid: boolean
  issues: ValidationIssue[]
}

export interface ValidationIssue {
  type: 'error' | 'warning' | 'info'
  message: string
  entityId?: string
  entityType?: 'question' | 'module' | 'level'
}
